import { Component, ViewChild } from '@angular/core';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AssetService } from '../../Model/AssetModule/asset.service';
import { CommonModule } from '@angular/common';
import { RouterModule, RouterOutlet } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AssetAdditionalDetailComponent } from '../asset-additional-detail/asset-additional-detail.component';
import { CommonService } from '../../Model/Common/common.service';

@Component({
  selector: 'app-asset-addition',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, DataTablesModule],
  templateUrl: './asset-addition.component.html',
  styleUrl: './asset-addition.component.scss'
})
export class AssetAdditionComponent {
  isDisabled: boolean = false;

  TableDatas = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  dtoptions: DataTables.Settings = {};
  constructor(
    private Asset: AssetService,
    private modalService: NgbModal,
    protected common: CommonService
  ) { 
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.LoadAssetMaster();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
  Link(Text: string) {
    return this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + 'AssetAdditionAttachment' + '/' + Text;
  }
  LoadAssetMaster() {
    this.isDisabled = true;
    this.Asset.LoadAssetAdditionDetail({ SelectType: 1, ESS_AssetAdditionId: 0 }).subscribe({
      next: (response) => {
        this.TableDatas = Object.values(response);

        const distinctAssets = response.filter((value: any, index: any, self: any) =>
          index === self.findIndex((t: any) => (
            t.ESS_AssetAdditionId === value.ESS_AssetAdditionId
          ))
        );
        this.TableDatas = distinctAssets;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

}
